import React, { Component } from 'react';
import TnC from './TnC'
import Privacy from './Privacy'
import ChronicConditionsModal from 'xAppLib/UIelems/HobbiesModal';
import MedicalHistoryModal from 'xAppLib/UIelems/MedicalHistoryModal';

const Content = ({ name, target="iscr", ...props }) => {
	let c = "NOT FOUND"
	switch(name){

		case 'privacy-policy':
			c = <Privacy />
			break;
		case 'terms-and-conditions':
			c = <TnC type={target}/>
			break;
		case 'hobbies':
			c = <ChronicConditionsModal {...props} />
			break;
		case 'medical-history':
			c = <MedicalHistoryModal {...props} />
			break;
		case 'medical-history-and-chro-cond':
			c = <MedicalHistoryModal navigateToHobbies {...props} />
			break;
	}
	return c
}
	

export default Content
